module.exports = __webpack_public_path__ + "static/media/reset-password.0a4cc9cd.jpg";